/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import styles from "../Styles/dashboard.module.css";
import { Vocabulary } from "../Utils/Vocabulary";
import { urlEnum } from "../Utils/UrlEnum";
import MainTable from "../Components/GenericComponents/MainTable";
import { useState } from "react";
import { useMediaQuery } from "@mui/material";

export default function Roles() {
  const phoneStyle = useMediaQuery("(max-width: 800px)");

  const roleHeader = [
    {
      label: Vocabulary.name,
      name: "name",
      options: { sort: false },
    },
    {
      label: Vocabulary.displayName,
      name: "displayName",
      options: {
        sort: false,
      },
    },
  ];

  return (
    <div
      className={phoneStyle ? styles.mainContainerMobile : styles.mainContainer}
    >
      <MainTable
        urlEnumApi={urlEnum.roles}
        header={roleHeader}
        tableTitle={Vocabulary.rolesList}
        hideOptionButtons={{
          add: true,
          edit: {
            condition: (item: any) => true,
          },
          delete: {
            condition: (item: any) => true,
          },
        }}
      />
    </div>
  );
}
